import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

// import { getLoading, getErrorMessage } from '../../../store/reducers/ui.reducer';
import { State } from '../../../store/reducers';

import * as fromUI from '../../../store/actions/ui.action';
import * as fromBooking from '../../../store/actions/booking.action';
import { map } from 'rxjs/operators';
import { BookingService } from '../../services/booking.service';
import { country_list } from '../../../core/utilities/countries';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Booking } from '../../models/booking';

@Component({
  selector: 'app-edit-booking',
  templateUrl: './edit-booking.component.html',
  styleUrls: ['./edit-booking.component.css']
})
export class EditBookingComponent implements OnInit {
  part = 'details';
  countries: string[];
  availableRooms$: Observable<any>;
  loading$: Observable<boolean>;

  detailsFilled$: Observable<any>;
  selectedRoom$: Observable<any>;
  selectedTours$: Observable<any>;
  bookingPrice$: Observable<number>;

  errorMessage$: Observable<any>;
  bookingForm: FormGroup;
  editableBooking: any;

  tourPriceMap = {
    soweto: 50,
    'sun city': 75,
    'union building': 40,
    'gold reef city': 65
  };

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<State>,
    private spinnerService: Ng4LoadingSpinnerService,
    public bookingService: BookingService
  ) {
    // const bookingId = this.route.snapshot.paramMap.get('id');
    // store.dispatch(new fromBooking.GetCurrentBooking(bookingId));
  }

  ngOnInit() {
    // this.countries = country_list;
    // this.store
    //   .select(state => state.booking.currentBooking)
    //   .subscribe(booking => (this.editableBooking = booking));
    // this.initializeForm();
    // this.setFormValues(this.editableBooking);
    // this.availableRooms$ = this.store.select(
    //   state => state.rooms.availableRooms
    // );
    // this.detailsFilled$ = this.store.select(
    //   state => state.booking.cumulator.details
    // );
    // this.selectedRoom$ = this.store.select(
    //   state => state.booking.cumulator.room
    // );
    // this.selectedTours$ = this.store.select(
    //   state => state.booking.cumulator.tours
    // );
    // this.bookingPrice$ = this.store.select(
    //   state => state.booking.cumulator.price
    // );
    // this.bookingForm
    //   .get('includeSowetoTour')
    //   .valueChanges.pipe(
    //     map(value => {
    //       if (value) {
    //         this.store.dispatch(new fromBooking.IncludeSowetoTour());
    //       } else {
    //         this.store.dispatch(new fromBooking.ExcludeSowetoTour());
    //       }
    //     })
    //   )
    //   .subscribe();
    // this.bookingForm
    //   .get('includeUnionBuildingTour')
    //   .valueChanges.pipe(
    //     map(value => {
    //       if (value) {
    //         this.store.dispatch(new fromBooking.IncludeUnionBuildingTour());
    //       } else {
    //         this.store.dispatch(new fromBooking.ExcludeUnionBuildingTour());
    //       }
    //     })
    //   )
    //   .subscribe();
    // this.bookingForm
    //   .get('includeSunCityTour')
    //   .valueChanges.pipe(
    //     map(value => {
    //       if (value) {
    //         this.store.dispatch(new fromBooking.IncludeSunCityTour());
    //       } else {
    //         this.store.dispatch(new fromBooking.ExcludeSunCityTour());
    //       }
    //     })
    //   )
    //   .subscribe();
    // this.bookingForm
    //   .get('includeGoldReefCityTour')
    //   .valueChanges.pipe(
    //     map(value => {
    //       if (value) {
    //         this.store.dispatch(new fromBooking.IncludeGoldReefCityTour());
    //       } else {
    //         this.store.dispatch(new fromBooking.ExcludeGoldReefCityTour());
    //       }
    //     })
    //   )
    //   .subscribe();
  }

  // initializeForm() {
  //   this.bookingForm = this.fb.group({
  //     id: '',
  //     email: '',
  //     firstNames: '',
  //     lastName: '',
  //     nameOfChurch: '',
  //     gender: '',
  //     country: '',
  //     idNumber: '',
  //     mobilePhone: '',
  //     otherInfo: '',
  //     meal1: '',
  //     meal2: '',
  //     meal3: '',
  //     selectedRoom: '',
  //     includeSowetoTour: false,
  //     includeUnionBuildingTour: false,
  //     includeSunCityTour: false,
  //     includeGoldReefCityTour: false,
  //     bookingPrice: 0
  //   });
  // }

  // setFormValues(booking: Booking | any): void {
  //   this.bookingForm.patchValue({
  //     id: booking.id,
  //     email: booking.email,
  //     firstNames: booking.firstNames,
  //     lastName: booking.lastName,
  //     nameOfChurch: booking.nameOfChurch,
  //     gender: booking.gender,
  //     country: booking.country,
  //     idNumber: booking.idNumber,
  //     mobilePhone: booking.mobilePhone,
  //     otherInfo: booking.otherInfo,
  //     meal1: booking.meal1,
  //     meal2: booking.meal2,
  //     meal3: booking.meal3,
  //     selectedRoom: booking.selectedRoom,
  //     includeSowetoTour: booking.includeSowetoTour,
  //     includeUnionBuildingTour: booking.includeUnionBuildingTour,
  //     includeSunCityTour: booking.includeSunCityTour,
  //     includeGoldReefCityTour: booking.includeGoldReefCityTour,
  //     bookingPrice: booking.bookingPrice
  //   });
  // }

  // cumulateBookingDetails() {
  //   const values = this.bookingForm.value;
  //   const details = {
  //     'First Names': values.firstNames,
  //     'Last Name': values.lastName,
  //     Email: values.email,
  //     'Name of Church': values.nameOfChurch,
  //     Gender: values.gender,
  //     Country: values.country,
  //     'ID / Passport': values.idNumber,
  //     'Mobile Phone': values.mobilePhone,
  //     'Other Info': values.otherInfo,
  //     'Day 1 meal': values.meal1,
  //     'Day 2 meal': values.meal2,
  //     'Day 3 meal': values.meal3
  //   };
  //   // this.store.dispatch(new fromBooking.CollectDetails(details));
  //   this.part = 'rooms';
  // }

  // cumulateSelectedRoom(room) {
  //   this.bookingForm.get('selectedRoom').setValue(room.name);
  //   this.store.dispatch(new fromBooking.CollectSelectedRoom(room));
  //   this.part = 'tours';
  // }

  // editBooking() {
  //   console.log(this.bookingForm.value);
  //   this.store.dispatch(new fromUI.PageLoading());
  //   this.spinnerService.show();
  //   this.loading$ = this.store.select(state => state.ui.loading);
  //   this.bookingPrice$.subscribe(price => {
  //     this.bookingForm.get('bookingPrice').setValue(price);
  //   });
  //   this.store.dispatch(new fromBooking.EditBooking(this.bookingForm.value));
  //   this.errorMessage$ = this.store.select(state => state.ui.error);
  // }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/containers/edit-booking/edit-booking.component.ts